import {
  GET_CURRENT_USER,
  SAVE_CURRENT_USER,
  LOGOUT,
} from './actionTypes'

export const getCurrentUser = () => ({ type: GET_CURRENT_USER})
export const saveCurrentUser = payload => ({ type: SAVE_CURRENT_USER, payload })
export const logout = payload => ({ type: LOGOUT, payload })